/**
 * @generated SignedSource<<b268e431d1eff6d25f8d8b69625a6ffc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationFlyerProvider = "EKOSTORMARKNAD" | "EMAGIN" | "EREKLAMBLAD";
export type IntegrationFlyerCreateScreenFlyerMutation$variables = {
  id: string;
  provider: IntegrationFlyerProvider;
};
export type IntegrationFlyerCreateScreenFlyerMutation$data = {
  readonly store: {
    readonly createIntegrationFlyer: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationFlyerCreateScreenFlyerMutation = {
  response: IntegrationFlyerCreateScreenFlyerMutation$data;
  variables: IntegrationFlyerCreateScreenFlyerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provider"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "provider",
            "variableName": "provider"
          }
        ],
        "concreteType": "IntegrationEmaginFlyer",
        "kind": "LinkedField",
        "name": "createIntegrationFlyer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationFlyerCreateScreenFlyerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationFlyerCreateScreenFlyerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0b448ca48fd2d6ad99fcc22707f2f670",
    "id": null,
    "metadata": {},
    "name": "IntegrationFlyerCreateScreenFlyerMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationFlyerCreateScreenFlyerMutation(\n  $id: String!\n  $provider: IntegrationFlyerProvider!\n) {\n  store {\n    createIntegrationFlyer(id: $id, provider: $provider) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b8c368ebc9ba28de9c23220b455ece6";

export default node;
